import {Injectable} from '@angular/core';
import {CanActivate, Router,ActivatedRouteSnapshot,RouterStateSnapshot,UrlTree} from '@angular/router';
import {LoginService} from '../login/login.service';

@Injectable({
    providedIn: 'root'
})
export class LoginInGuardService implements CanActivate {

    constructor(private router: Router, public loginService: LoginService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean |
        UrlTree {
        // returns `true` if the user is logged in or redirects to the login page
        // note that you can also use `router.createUrlTree()` to build a `UrlTree` with parameters
        return this.loginService.isLoggedIn() || this.router.parseUrl('/login');
    }

}
@Injectable({
    providedIn: 'root'
})
export class LoginInSAService implements CanActivate {

    constructor(private router: Router, public loginService: LoginService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean |
        UrlTree {
        // returns `true` if the user is logged in or redirects to the login page
        // note that you can also use `router.createUrlTree()` to build a `UrlTree` with parameters
        return this.loginService.isLoggedAdmin() || this.router.parseUrl('/');
    }

}
